export default [
  {
    path: '/contacts',
    name: 'contacts',
    component: () => import('@/views/modules/Contacts/index.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'sidebar.supply',
          active: true,
        },
        {
          text: 'contact.contacts',
          active: true,
        },
      ],
    },
  },
  {
    path: '/contacts/detail/:id',
    name: 'contacts-detail',
    component: () => import('@/views/modules/Contacts/component/detailContact.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'sidebar.supply',
          active: true,
        },
        {
          text: 'contact.contacts',
          to: '/contacts',
          active: false,
        },
        {
          text: 'contact.contact_details',
          active: true,
        },
      ],
    },
  },
  {
    path: '/pto',
    name: 'pto',
    component: () => import('@/views/modules/Pto/index.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'pto',
          active: true,
        },
        {
          text: 'sidebar.pto',
          active: true,
        }
      ],
    },
  },
  // {
  //   path: '/pto/detail/:id',
  //   name: 'pto-detail',
  //   component: () => import('@/views/modules/ListAppeal/detailTable.vue'),
  //   meta: {
  //     pageTitle: '',
  //     breadcrumb: [
  //       {
  //         text: 'sidebar.pto',
  //         active: false,
  //       },
  //       {
  //         text: 'sidebar.pto',
  //         to: '/pto',
  //         active: false,
  //       },
  //       {
  //         text: 'warehouses',
  //         active: true,
  //       },
  //     ],
  //   },
  // },
  // {
  //   path: '/pto/detail/:id/Warehouse/:warehouseId',
  //   name: 'pto-detail-id-warehouse-warehouseId',
  //   component: () => import('@/views/modules/Pto/components/index.vue'),
  //   meta: {
  //     pageTitle: '',
  //     breadcrumb: [
  //       {
  //         text: 'sidebar.pto',
  //         to: '/pto',
  //         active: false,
  //       },
  //       {
  //         text: 'warehouses',
  //         to: '/pto',
  //         active: false,
  //       },
  //       {
  //         text: 'Название склады',
  //         active: true,
  //       },
  //     ],
  //   },
  // },
  {
    path: '/moving',
    name: 'moving',
    component: () => import('@/views/modules/Applications/Moving/index.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'sidebar.list_of_applications',
          active: true,
        },
        {
          text: 'sidebar.movement',
          active: true,
        },
      ],
    },
  },
  {
    path: '/moving/add',
    name: 'moving-add',
    component: () => import('@/views/modules/Applications/Moving/components/addEditPage.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'sidebar.list_of_applications',
          active: true,
        },
        {
          text: 'sidebar.movement',
          to: '/moving',
          active: false,
        },
        {
          text: 'adding',
          to: '/moving',
          active: true,
        },
      ],
    },
  },
  {
    path: '/moving/view/:type/:id',
    name: 'moving-view',
    component: () => import('@/views/modules/Applications/Moving/components/view.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'sidebar.list_of_applications',
          active: true,
        },
        {
          text: 'sidebar.movement',
          to: '/moving',
          active: false,
        },
        {
          text: 'watch',
          active: true,
        },
      ],
    },
  },
  {
    path: '/moving/edit/:id',
    name: 'moving-edit',
    component: () => import('@/views/modules/Applications/Moving/components/addEditPage.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'sidebar.list_of_applications',
          active: true,
        },
        {
          text: 'sidebar.movement',
          to: '/moving',
          active: false,
        },
        {
          text: 'editing',
          active: true,
        },
      ],
    },
  },

  // Возврат
  {
    path: '/return',
    name: 'return',
    component: () => import('@/views/modules/Applications/return/index.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'sidebar.list_of_applications',
          active: true,
        },
        {
          text: 'sidebar.for_return',
          active: true,
        },
      ],
    },
  },
  // {
  //   path: '/return/add',
  //   name: 'return-add',
  //   component: () => import('@/views/modules/Applications/return/components/addEditAll.vue'),
  //   meta: {
  //     pageTitle: '',
  //     breadcrumb: [{
  //       text: 'sidebar.for_return Добавить (все)',
  //       to: '/return',
  //       active: false,
  //     },
  //     ],
  //   },
  // },
  // {
  //   path: '/return/hour',
  //   name: 'return-hour',
  //   component: () => import('@/views/modules/Applications/return/components/addEditHour.vue'),
  //   meta: {
  //     pageTitle: '',
  //     breadcrumb: [{
  //       text: 'sidebar.for_return Добавить (часть)',
  //       to: '/return',
  //       active: false,
  //     },
  //     ],
  //   },
  // },
  {
    path: '/return/view/material/:id',
    name: 'return-view-material-id',
    component: () => import('@/views/modules/Applications/return/components/viewMaterials.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'sidebar.list_of_applications',
          active: true,
        },
        {
          text: 'sidebar.for_return',
          to: '/return',
          active: false,
        },
        {
          text: 'watch_materials',
          active: true,
        },
      ],
    },
  },
  {
    path: '/return/view/instrument/:id',
    name: 'return-view-instrument-id',
    component: () => import('@/views/modules/Applications/return/components/viewInstruments.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'sidebar.list_of_applications',
          active: true,
        },
        {
          text: 'sidebar.for_return',
          to: '/return',
          active: false,
        },
        {
          text: 'watch_instruments',
          active: true,
        },
      ],
    },
  },
  // {
  //   path: '/return/view/host/:id',
  //   name: 'return-view-host',
  //   component: () => import('@/views/modules/Applications/return/components/returnViewHost.vue'),
  //   meta: {
  //     pageTitle: '',
  //     breadcrumb: [
  //       {
  //         text: 'sidebar.movement',
  //         to: '/return',
  //         active: false,
  //       },
  //       {
  //         text: 'sidebar.movement view',
  //         active: true,
  //       },
  //     ],
  //   },
  // },

  /// report
  {
    path: '/report',
    name: 'report',
    component: () => import('@/views/modules/report/index.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'sidebar.reports',
          active: true,
        },
        {
          text: 'sidebar.reports_pto',
          active: false,
          to: '/report'
        },
      ],
    },
  },
  {
    path: '/work-report',
    name: 'work-report',
    component: () => import('@/views/modules/report/WorkReports.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'sidebar.reports',
          active: true,
        },
        {
          text: 'sidebar.work_report',
          active: false,
          to: '/work-report'
        },
      ],
    },
  },
  {
    path: '/good-report',
    name: 'good-report',
    component: () => import('@/views/modules/report/GoodReports.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'sidebar.reports',
          active: true,
        },
        {
          text: 'sidebar.good_report',
          active: true,
          to: '/good-report'
        },
      ],
    },
  },
  {
    path: '/work-view-report',
    name: 'work-view-report',
    component: () => import('@/views/modules/report/WorkViewReports.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'sidebar.reports',
          active: true,
        },
        {
          text: 'sidebar.work_view_report',
          active: true,
          to: '/work-view-report'
        },
      ],
    },
  },
  {
    path: '/report/:id',
    name: 'report-detail',
    component: () => import('@/views/modules/report/DetailReport.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'sidebar.reports',
          active: true,
        },
        {
          text: 'sidebar.reports_pto',
          active: false,
          to: '/report'
        },
        {
          text: 'sidebar.pto',
          active: true,
        },
      ],
    },
  },


  {
    path: '/notifications',
    name: 'notifications',
    component: () => import('@/views/modules/components/Notifications'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'notifications',
          active: true,
        },
      ],
    },
  },
]
